module.exports = Backbone.Model.extend({
    defaults: {
        name: null,
        email: null,
        passwordToken: null,
        trackingCategory: 'prime_onboarding',
        trackingLabelSuffix: 'prime-onb',
    },

    updateTokenInfo(info) {
        this.set('name', info.name);
        this.set('email', info.email);
    },
});
